import { SelectedImage, SetState } from 'types'
import Styles from './UploadFromLibrary.module.scss'
import { useUploads } from 'components/Design/UploadsTab/useUploads'
import { collectResults } from 'utils/query'
import { getMediaFiles } from 'components/Design/UploadsTab/getMediaFiles'
import Preview from '../../Preview'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ACCEPTED_IMAGE_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'

interface Props {
  stagedImages: SelectedImage[]
  selectedImages: SelectedImage[]
  setSelectedImages: SetState<SelectedImage[]>
  setStagedImages: SetState<SelectedImage[]>
  multiSelect?: boolean
  useCarousel?: boolean
}

export const UploadFromLibrary = ({ setSelectedImages, selectedImages, multiSelect, useCarousel }: Props) => {
  const uploadsQuery = useUploads()
  const { isDesktop } = useResponsiveDesign()
  const uploads = collectResults(uploadsQuery, (data) => data.files)
  const mediaFiles = getMediaFiles(uploads, ACCEPTED_IMAGE_MIME_TYPES)
  const mediaFilesAsSelectedImages: SelectedImage[] = mediaFiles.map((mf) => ({ ...mf, url: mf.source_url }))

  return (
    <div className={Styles.container}>
      {isDesktop && <h3>Uploads Library</h3>}
      <Preview
        stagedImages={mediaFilesAsSelectedImages}
        selectedImages={selectedImages}
        setSelectedImages={setSelectedImages}
        multiSelect={multiSelect}
        loadMore={uploadsQuery.fetchNextPage}
        hasMore={uploadsQuery.hasNextPage}
        useCarousel={useCarousel}
      />
    </div>
  )
}
